import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'
import * as XLSX from 'sheetjs-style'

import {
  Column,
  Table as ReactTable,
  PaginationState,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  ColumnDef,
  OnChangeFn,
  flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import { initialQueryState, KTIcon, useDebounce } from '../../../../_metronic/helpers'







export function CampaignPerformanace() {


  const navigate = useNavigate()
  const editItem = (data: any) => {
    console.log(data.original)
    navigate('/EditParticipant', { state: data.original })
  }



  const [tableData, setTableData] = useState<any>([])
  //const rerender = React.useReducer(() => ({}), {})[1]
  const API_URL = process.env.REACT_APP_API_URL
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'mobile_number',
        header: 'DATE',
        footer: (props) => props.column.id,
        cell: (props) => <p>{dayjs(props.row.original.created_date).format('DD-MM-YYYY')}</p>,
      },
      {
        accessorKey: 'company_id',
        header: 'UserID',
        cell: (props) => <span className='down50 sorting_1'>{props.row.original.company_id
        }</span>,
        footer: (props) => props.column.id,
      },

      {
        accessorKey: 'point',
        header: 'privilege_redeem_id',
        cell: (props) => <span className='down50 sorting_1'>{props.row.original.point}</span>,
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'id',
        header: 'privilege_code',
        cell: (props) => <span className='down50 sorting_1'>${props.row.original.id}</span>,
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'id',
        header: 'deal_name',
        cell: (props) => <span className='down50'>${props.row.original.id * 2}</span>,
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'id',
        header: 'used_at',
        cell: (props) => <span className='down50'>${props.row.original.id * 2}</span>,
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'id',
        header: 'expire_used_at',
        cell: (props) => <span className='down50'>${props.row.original.id * 2}</span>,
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'id',
        header: 'Created_at',
        cell: (props) => <span className='down50'>${props.row.original.id * 2}</span>,
        footer: (props) => props.column.id,
      },

      // {
      //   accessorKey: 'firstname',
      //   header: 'Firstname',
      //   cell: (props) => <span className='down50'>{props.row.original.firstname}</span>,
      //   footer: (props) => props.column.id,
      // },
      // {
      //   accessorKey: 'lastname',
      //   header: 'Lastname',
      //   footer: (props) => props.column.id,
      // },
      /*{
        accessorKey: 'email',
        header: 'Email',
        footer: (props) => props.column.id,
      },*/
      // {
      //   accessorKey: 'code',
      //   header: 'ทะเบียนรถ',
      //   footer: (props) => props.column.id,
      // },

      // {
      //   accessorKey: 'mobile_number',
      //   header: 'Type',
      //   footer: (props) => props.column.id,
      //   cell: (props) => <p>{props.row.original.participantsMasters.length > 0 ? props.row.original.participantsMasters[0].type : ''}</p>,
      // },

      // {
      //   accessorKey: 'mobile_number',
      //   header: 'mobile_number',
      //   footer: (props) => props.column.id,
      // },


      // {
      //   accessorKey: 'point',
      //   header: 'Remain Point',
      //   footer: (props) => props.column.id,
      //   cell: (props) => <p>{Number(props.row.original.point).toFixed(0)}</p>,

      // },
    ],
    []
  )

  const [data, setData] = React.useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPage, setTotalPage] = useState(1)
  const [totalRow, setTotalRow] = useState(10)
  const getAPI = async () => {
    const data = await axios
      .get(`${API_URL}/bo/participant?page=1&limit=10&verify=1`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setPage(res.data.page)
        setLimit(res.data.limit)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
    //return data.data.data
  }

  const handlePageChange = (newPage: number) => {
    if (newPage <= totalPage && newPage > 0) {
      setPage(newPage);
      refreshAPI(newPage, limit);
    }
  };

  const refreshAPI = async (page: Number, limit: Number) => {
    const data = await axios
      .get(`${API_URL}/bo/participant?page=${page}&limit=${limit}&verify=1`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }

  const [searchTerm, setSearchTerm] = useState<string>('')
  const refreshAPISearch = async (search: string) => {
    setSearchTerm(search)
    const data = await axios
      .get(`${API_URL}/bo/participant?page=${1}&limit=${limit}&search=${search}&verify=1`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setPage(1)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: true,
  })
  useEffect(
    () => {
      getAPI()
    },
    [] // Only re-call effect if value or delay changes
  )
  const [col, setCol] = useState<any>([])
  const [rows, setRows] = useState<any>([])
  const exportExcel = async () => {
    const data = await axios
      .get(`${API_URL}/bo/participant?page=1&limit=10000&verify=1`)
      .then(async (res) => {
        var _data = res.data.data
        var key = []

        _data.map((item: any, num: any) => {
          const alphaNumOut = Object.keys(item).map((key) => item[key])

          rows.push(alphaNumOut)
        })
        const datas = [...rows]
        //const reportTitle = listReport.find((d) => Number(d.id) == Number(reportValue)).title
        const fileName = `verify.xlsx`
        const ws = XLSX.utils.aoa_to_sheet([[]])
        const wb = XLSX.utils.book_new()

        XLSX.utils.sheet_add_aoa(ws, datas)
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        XLSX.writeFile(wb, fileName)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <Card className='table-responsive fontWrap'>
      <Card.Header>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search Report'
            value={searchTerm}
            onChange={(e) => refreshAPISearch(e.target.value)}
          />
        </div>
        {/** add button จุดเพิ่มปุ่ม */}
        <div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          <button type='button' className='btn btn-light-primary me-3' onClick={() => { exportExcel() }}>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>

          {/*<button type='button' className='btn btn-primary' onClick={() => {}}>
            <KTIcon iconName='plus' className='fs-2' />
            Add User
          </button>*/}
        </div>
      </Card.Header>
      <table className='table table-striped gy-7 gs-7'>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div className='fw-bold fs-7 text-gray-1200 border-bottom-2 border-gray-200'>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  )
                })}
                {/**add button เพิ่มปุ่ม */}

              </tr>
            )
          })}
        </tbody>
      </table>



      <div className='h-2' />
      {/* //pagination */}
      <Card.Footer>
        <div className='row'>
          <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
            <span>
              <select
                className='form-select form-select-sm form-select-solid'
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value))
                  refreshAPI(page, Number(e.target.value))
                  table.setPageSize(Number(e.target.value))
                }}
              >
                {[10, 20, 30, 40, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>

            <div>
              <ul className="pagination">
                <li className="page-item previous disabled">
                  <a href="#" className="page-link">
                    <i className="previous"></i>
                  </a>
                </li>
                {[...Array(totalPage)].map((_, index) => (
                  <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                    <a href="#" className="page-link" onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </a>
                  </li>
                ))}
                <li className="page-item next">
                  <a href="#" className="page-link">
                    <i className="next"></i>
                  </a>
                </li>
              </ul>

            </div>
          </div>


        </div>
        {/* <span className='flex items-center gap-1'>
          <strong>
            Page {page} of {totalPage}
          </strong>
        </span>
        <span className='flex items-center gap-1 mr-3 p-4'>
          | Go to page:




        </span> */}

      </Card.Footer>
    </Card>
  )
}
